module.exports = __webpack_public_path__ + "static/aer-logo-851721ff9f69231b20786e873ab117c6.png";